import { Component, OnInit, ChangeDetectionStrategy, ViewChild, TemplateRef, OnDestroy, Inject } from '@angular/core';
import { MinhaAgenda } from '@app/models/minha-agenda';
import { CalendarEvent, CalendarEventTimesChangedEvent } from 'angular-calendar';
import { CDSMask } from '@app/utils/cds-mask';
import { MinhaAgendaService } from '@app/services/minha-agenda.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { HomeService } from '@app/services/home.service';
import { MeAviseHomeViewModel } from '@app/models/me-avise-home-view-model';
import { Funcionario } from '@app/models/funcionario';
import { UtilitarioService } from '@app/services/utilitario.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ConsultasService } from '@app/services/consultas.service';
import { LoginService } from '@app/services/login.service';
import { ValidaDocumento } from '@app/utils/valida-documento';
import { FuncionarioService } from '@app/services/funcionario.service';
import { LoginComponent } from '../login/login.component';
import {
  isSameMonth, isSameDay, startOfMonth, endOfMonth, startOfWeek, endOfWeek, startOfDay, endOfDay, format
} from 'date-fns';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardComponent implements OnInit, OnDestroy {

  aguardandoSolicitacao: boolean;
  agendaModal: MinhaAgenda;
  deletarRef: BsModalRef;

  lstMinhaAgenda: MinhaAgenda[] = [];
  lstMinhaAgendaDiaSelecionado: MinhaAgenda[] = [];
  events: CalendarEvent[] = [];
  activeDayIsOpen = false;
  dataHoje = new Date();
  dataHojeSomada = this.dataHoje.setDate(this.dataHoje.getDate() + 60);
  minhaAgenda: MinhaAgenda = new MinhaAgenda();
  cdsMask: CDSMask = new CDSMask();
  lstErros: string[] = [];
  lstMeAviseHome: MeAviseHomeViewModel[] = [];
  lstMeAviseHomeAudiencia: MeAviseHomeViewModel[] = [];
  lstPrazoAdvogado: MeAviseHomeViewModel[] = [];
  isDataLoaded = false;

  buscaProcesso = '';
  buscaParticipante = '';
  exibirAtendimento = false;
  avisoAudienciaNoDia = 0;

  lstAdvogados: Funcionario[] = [];
  buscarAgendaDeOutroUsuarioId;
  mostrarAudiencia = false;
  mostrarMinhaAgenda = false;
  mostrarApenasDia = true;
  funcionario: Funcionario;

  bsModalRef: BsModalRef;
  modalPrazos: BsModalRef;
  modalConfirmacao: BsModalRef;

  ordemCampo = '';
  ordemTipo = '';

  colors: any = {
    red: {
      primary: '#ad2121',
      secondary: '#FAE3E3'
    },
    blue: {
      primary: '#1e90ff',
      secondary: '#D1E8FF'
    },
    yellow: {
      primary: '#e3bc08',
      secondary: '#FDF1BA'
    }
  };

  possuiPrazoModal = false;
  possuiPrazoMeAvise = false;
  naoMostrarNovamente: boolean = false;

  // calendario
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  @ViewChild('content', { static: true }) modalContentAdvogado: TemplateRef<any>;
  @ViewChild('editarAgenda', { static: true }) editarAgendaRef: TemplateRef<any>;
  @ViewChild('modalconf', { static: true }) modalContentConfirmacao: TemplateRef<any>;
  @ViewChild('modalautenti', { static: true }) modalContentAutentificacao: TemplateRef<any>;

  view: 'day' | 'week' | 'month' = 'day';

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };
  botaoDesabilitado: boolean = false;

  refresh: Subject<any> = new Subject();
  possuiAutenticacaoHabilitada: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private minhaAgendaService: MinhaAgendaService,
    private consultasService: ConsultasService,
    private homeService: HomeService,
    private _modalService: BsModalService,
    @Inject(ToastrService) public toastr: ToastrService,
    private modalService: BsModalService,
    private loginService: LoginService,
  ) {
  }
  ngOnInit() {
    const hoje = new Date();
    const horas = UtilitarioService.adicionaZero(hoje.getHours());
    const minutos = UtilitarioService.adicionaZero(hoje.getMinutes());

    this.minhaAgenda.DataAgendada = UtilitarioService.retornaDataAtualMaisDias(0);
    this.minhaAgenda.HoraInicioAgendada = horas + ':' + minutos;
    this.minhaAgenda.UsuarioId = 0;

    localStorage.removeItem('botaoDesabilitado');
    this.botaoDesabilitado = false;
    
    this.consultasService.consultar('USUARIO').toPromise().then(data => {
      this.lstAdvogados = new Array(data.length);
      data.forEach((element, index) => {
        let funcionario = new Funcionario();
        funcionario.NomeFantasia = element.Descricao;
        funcionario.Id = element.Id;
        this.lstAdvogados[index] = funcionario;
      });
      const agendaOutroUsuarioId = window.sessionStorage.getItem('agendaOutroUsuarioid');
      window.sessionStorage.removeItem('agendaOutroUsuarioid');
      this.obterTodos('', '', this.buscarAgendaDeOutroUsuarioId)

      this.refresh.next();
    });
    this.obterListaMeAvise();

    const prazoLido = window.sessionStorage.getItem('LstPrazoAdvogadoLido');
    if (prazoLido !== 'True') {
      this.obterListaPrazoAdvogado();
    }

    // const possuiAutenticacaoDoisFatores = JSON.parse(localStorage.getItem('Autenticacao.Habilitada'));
    // const naoMostrarNovamente = sessionStorage.getItem('naoMostrarNovamente') ?? 'False';

    // if (possuiAutenticacaoDoisFatores === false && naoMostrarNovamente === 'False') {
    //   this.naoMostrarNovamente = false;
    //   this.abrirModalConf();
    // }
  }
  
  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }

    }
    this.alterarAgendaDoDiaSelecionado(UtilitarioService.retornaData(date));
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd
  }: CalendarEventTimesChangedEvent): void {
    event.start = newStart;
    event.end = newEnd;
    this.handleEvent('Dropped or resized', event);
    this.refresh.next();
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    this._modalService.show(this.modalContent);
  }

  retornaCaminho(idProcesso: number, tipoMovimentacaoId: number): string {
    return '/processos/processo/' + idProcesso + UtilitarioService.retornaTipoMovimentacao(tipoMovimentacaoId);
  }

  retornaCaminhoEditar(meAviseId: number): string {
    return '/meavise/' + meAviseId;
  }

  obterTodos(dataInicial: string = '', dataFinal: string = '', usuarioId = null) {
    this.minhaAgenda.Descricao = '';
    this.minhaAgendaService.obterMinhaAgendaHome(this.view, dataInicial, dataFinal, this.exibirAtendimento, usuarioId)
      .toPromise().then(data => {
        this.lstMinhaAgenda = data;
        this.alterarAgendaDiaSelecionaAnteriorProximo();
        this.events = [];
        for (let i = 0; i < this.lstMinhaAgenda.length; i++) {
          const minhaAgenda = this.lstMinhaAgenda[i];
          const HoraInicioAgendada = minhaAgenda.HoraInicioAgendada.split(':');
          const dataAgendada = minhaAgenda.DataAgendada.toString().split('T')[0].split('-');

          const dd = parseInt(dataAgendada[2], 10);
          const monthIndex = parseInt(dataAgendada[1], 10) - 1;
          const yyyy = parseInt(dataAgendada[0], 10);
          const audiencia = minhaAgenda.Audiencia ? ' (AUDIÊNCIA) ' : '';
          const cancelado = minhaAgenda.Cancelado ? ' <strong style="color:red!important;">(CANCELADO)</strong>' : '';
          const realizado1 = minhaAgenda.Realizado ? '<strike>' : '';
          const realizado2 = minhaAgenda.Realizado ? '</strike>' : '';
          if (new Date(yyyy, monthIndex, dd).toDateString() === this.dataHoje.toDateString()) {
            this.activeDayIsOpen = true;
          }
          minhaAgenda.ClienteNome = minhaAgenda.ClienteNome == null ? 'Sem Cliente' : minhaAgenda.ClienteNome;

          let _actions = [];

          if (!minhaAgenda.Atendimento) {
            _actions = [{
              label: minhaAgenda.ProcessoId > 0 ? '<i class="fa fa-fw fa-search-plus fa-lg" style="color: blue;"></i> ' : '',
              onClick: ({ event }: { event: CalendarEvent }): void => {
                if (minhaAgenda.ProcessoId > 0) {
                  window.open('#/processos/processo/' + minhaAgenda.ProcessoId, "_blank");
                }
              }
            }, {
              label: minhaAgenda.Cancelado ? '' : minhaAgenda.Realizado ? '<i class="fa fa-fw fa-check-square-o fa-lg" style="color: blue;"></i> ' : '<i class="fa fa-fw fa-square-o fa-lg" style="color: blue;"></i> ',
              onClick: ({ event }: { event: CalendarEvent }): void => {
                this.realizarMinhaAgenda(minhaAgenda.Id, minhaAgenda.Realizado);
              }
            },
            {
              label: '<i class="fa fa-fw fa-pencil"></i>',
              onClick: ({ event }: { event: CalendarEvent }): void => {
                this.openEditarAgenda(minhaAgenda);
              }
            }
            ];
          }

          this.events.push({
            title: realizado1 + '<strong>' + minhaAgenda.HoraInicioAgendada + audiencia + '</strong>' + ' - ' + (minhaAgenda.Atendimento ? '(ATENDIMENTO) - ' : '') + minhaAgenda.ClienteNome + ' - ' + minhaAgenda.Descricao + cancelado + realizado2,
            start: new Date(yyyy, monthIndex, dd, Number.parseInt(HoraInicioAgendada[0], 10), Number.parseInt(HoraInicioAgendada[1], 10), 0),
            end: new Date(yyyy, monthIndex, dd, Number.parseInt(HoraInicioAgendada[0], 10) + 1, Number.parseInt(HoraInicioAgendada[1], 10), 0),
            color: minhaAgenda.Cancelado ? this.colors.red : minhaAgenda.EmDestaque ? this.colors.yellow : this.colors.blue,
            draggable: false,
            resizable: {
              beforeStart: true,
              afterEnd: true
            },
            actions: _actions,
          });
        }
        this.refresh.next();
      }
      );
  }

  openEditarAgenda(agenda: MinhaAgenda) {
    this.agendaModal = agenda;
    this.agendaModal.DataAgendada = agenda.DataAgendada.slice(0, 10);
    this.bsModalRef = this.modalService.show(this.editarAgendaRef, { class: 'modal-lg' });
  }

  onSubmitAgenda(){
    this.aguardandoSolicitacao = true;
    this.minhaAgendaService.gravar(this.agendaModal).toPromise().then(
    data => {
      if (data && data.error) {
        this.lstErros = data.error.errors;
      }
      this.aguardandoSolicitacao = false;
      this.bsModalRef.hide();
      this.obterTodos();
    });
  }

  deletarAgenda() {
    this.deletarRef = this.modalService.show(ModalConfirmarComponent);
    this.deletarRef.content.mensagem = 'Deseja realmente deletar este registro?';
    this.deletarRef.content.confirmar = () => {
      this.minhaAgendaService.deletar(this.agendaModal.Id).toPromise().then(
      data => {
        if (data && data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
        this.deletarRef.hide();
        this.bsModalRef.hide();
        this.obterTodos();
      });
    };
  }

  changeExibirAtendimento() {
    this.exibirAtendimento = !this.exibirAtendimento;
    this.viewDateChange(this.view);
  }

  obterListaMeAvise(buscarAgendaDeOutroUsuarioId: number = 0) {
    this.homeService.obterListaMeAvise(buscarAgendaDeOutroUsuarioId, this.ordemCampo, this.ordemTipo)
      .toPromise().then(data => {
        this.lstMeAviseHomeAudiencia = data.filter(x => x.Audiencia);
        this.lstMeAviseHome = data.filter(x => !x.Audiencia);
        this.avisoAudienciaNoDia = this.lstMeAviseHomeAudiencia.length;
        this.isDataLoaded = true;
        this.controlaColunasPrazo();
        this.refresh.next();
      });
  }

  obterListaPrazoAdvogado() {
    this.homeService.obterPrazoAdvogado()
      .toPromise().then(dataPrazos => {
        if (dataPrazos != null) {
          this.lstPrazoAdvogado = dataPrazos;
          this.controlaColunasPrazo();
          this.abrirModalAdvogado();
          this.refresh.next();
        }
      });
  }

  alterarAgendaDoDiaSelecionado(dataSelecionada: string) {
    // a data esta chegando dd/mm/aaaa mas nos precisamos de aaaa-mm-dd
    const dataSplit = dataSelecionada.split('/');
    const dia = dataSplit[0];
    const mes = dataSplit[1];
    const ano = dataSplit[2];
    dataSelecionada = [ano, mes, dia].join('-');

    this.lstMinhaAgendaDiaSelecionado = this.lstMinhaAgenda.filter(x => x.DataAgendada.split('T')[0] === dataSelecionada);
  }
  alterarAgendaDiaSelecionaAnteriorProximo() {
    this.alterarAgendaDoDiaSelecionado(UtilitarioService.retornaData(this.viewDate));
  }

  alteraAgenda() {
    this.obterTodos('', '', this.buscarAgendaDeOutroUsuarioId);
  }

  realizarMinhaAgenda(agendaId: number, realizado: boolean): boolean {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente realizar/desrealizar esse evento?';
    this.bsModalRef.content.confirmar = () => {
      this.minhaAgendaService.RealizarMinhaAgenda(agendaId).subscribe(data => {
        this.alteraAgenda();
        return !realizado;
      });
    };
    return realizado;
  }

  viewDateChange(type: 'day' | 'week' | 'month') {
    this.view = type;

    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay
    }[this.view];

    const dataInicial = format(getStart(this.viewDate), 'dd/MM/yyyy');
    const dataFinal = format(getEnd(this.viewDate), 'dd/MM/yyyy');

    this.obterTodos(dataInicial, dataFinal, this.buscarAgendaDeOutroUsuarioId);
    this.activeDayIsOpen = false;
  }

  // MODAL ADVOGADO
  abrirModalAdvogado() {
    this.modalPrazos = this.modalService.show(this.modalContentAdvogado, { class: 'modal-lg'});
  }

  marcarComoLido() {
    window.sessionStorage.setItem('LstPrazoAdvogadoLido', 'True');
    this.fecharModal(this.modalPrazos);
  }

  fecharModal(modalReferencia: BsModalRef): void {
    modalReferencia.hide();
  }

  // MODAL CONFIRMAÇÃO AUTENTICAÇÃO
  abrirModalConf() {
    this.modalConfirmacao = this.modalService.show(this.modalContentConfirmacao, { class: 'modal-lg' });
  }

  aoMarcarNaoMostrar() {
    window.sessionStorage.setItem('naoMostrarNovamente', 'True');
    this.naoMostrarNovamente = true;
  }

  fecharModalConf(modalConfirmacao: BsModalRef): void {
    modalConfirmacao.hide();
  }

  confirmarAut() {
    const login = localStorage.getItem('Cardeal.Login');
    const senha = localStorage.getItem('Cardeal.Senha');

    this.loginService.confirmarAutenticacao(login, senha).subscribe(
      () => {
        this.toastr.success("E-mail de confirmação enviado!");
        localStorage.setItem('Autenticacao.Habilitada', 'True');
      },
      (error) => {
        this.toastr.error("Erro ao enviar o E-mail de confirmação.", );
      }
    );

    this.fecharModal(this.modalConfirmacao);
  }

  ordem(ordemCampo: string) {
    if (ordemCampo === this.ordemCampo) {
      if (this.ordemTipo === 'desc') {
        this.ordemTipo = 'asc';
      } else {
        this.ordemTipo = 'desc';
      }
    } else {
      this.ordemTipo = 'asc';
    }
    this.ordemCampo = ordemCampo;
    this.obterListaMeAvise();
  }


  buscarProcesso() {
    this.router.navigate(['/processos/buscar-processos/', this.buscaProcesso]);
  }

  ngOnDestroy() {
    if (this.modalPrazos) {
      this.modalPrazos.hide();
    }
    if(this.modalConfirmacao)
    {
      this.modalConfirmacao.hide();
    }

  }

  controlaColunasPrazo() {
    this.possuiPrazoModal = this.lstPrazoAdvogado.some(item => item.Prazo !== null);
    this.possuiPrazoMeAvise = this.lstMeAviseHome.some(item => item.Prazo !== null);
  }
}
